import gql from 'graphql-tag';

import dokkioUserCapabilitiesFragment from './dokkioUserCapabilitiesFragment';
import remoteUserFragment from './remoteUserFragment';
import taskFragment from './taskFragment';

export const dokkioUserFragment = gql`
  fragment dokkioUserFragment on DokkioUser {
    dokkioClass
    id
    accountID
    dokkioGroupSlug
    role
    summary
    onboardingState
    isAccountOwner
    isPasswordSet
    isPending
    isOnboardingComplete
    primaryDisplayName
    primaryEmail
    primaryFirstName
    primaryImageURL
    primaryLastName
    suggestionsPopUpViewedAt
    suggestedTopicsPopUpViewedAt
    filteringPopUpViewedAt
    listSettingsPopUpViewedAt
    blogNotificationsViewedAt
    lastModifiedNotificationsViewedAt
    desktopAppInitialIntegrationsSetupAt
    desktopAppDownloadBannerDismissedAt
    credentialScopeUpgradeBannerDismissedAt
    sidebarInstallBannerDismissedAt
    createWebpageEnabled
    activeReferralDismissedAt
    showIntegrationThreads
    timeZone
    phoneNumber
    phoneNumberVerifiedAt
    smsOptedIn
    capabilities {
      ...dokkioUserCapabilitiesFragment
    }
    remoteUsers {
      ...remoteUserFragment
    }
    tasks {
      ...taskFragment
    }
    rowCreatedAt
  }
  ${dokkioUserCapabilitiesFragment}
  ${remoteUserFragment}
  ${taskFragment}
`;
export default dokkioUserFragment;
